import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, Input, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, AsyncValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SuperAdminService } from '../../../services/super-admin.service';
import { GlobalValidators } from '../../../utils/validators';
import { NgForm } from '@angular/forms';
import { Observable, of, from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpService } from '../../../services/http.service';

@Component({
  selector: 'app-signup-single-view',
  templateUrl: './signup-single-view.component.html',
  styleUrls: ['./signup-single-view.component.scss'],
})
export class SignupSingleViewComponent implements OnInit {
  // rmId = new FormControl();
  userId;
  pId;
  actTab: string;
  toggleStatus = {
    accountHolder: true,
    bankInfo: false,
    nominee1: false,
  };
  dataItem;
  prdSataInprogress;
  signUpActionList;
  signUpActionInProgress;
  confirmSignupFG: FormGroup;
  checkListInprogress;
  boidCheckInProgress = false;
  boidAvailabilityStatus: boolean = false;
  approvalInProgress;
  signatureInProgress;
  downloadApplicationInProgress;
  investerCodeSubmitted = false;
  successfullyApproved;
  downloadApplicationError: string;
  // Async validator for BOID availability (optional field)
  boidAvailabilityValidator = (control: AbstractControl): Observable<ValidationErrors | null> => {
    const boId = control.value;

    // If BOID is empty or just whitespace, it's valid (optional field)
    if (!boId || boId.trim() === '') {
      return of(null);
    }

    // If BOID is provided, validate it exists in the system
    return from(this.superAdminService.checkBoidAvailabilty(boId, this.userId)).pipe(
      map((res) => {
        if (res && res['boidExistsInSystem'] !== undefined) {
          if (!res['boidExistsInSystem']) {
            return null; // Valid - BOID exists
          } else {
            return { boidExistsInSystem: { message: 'BOID exist in the system' } };
          }
        } else {
          return { boidValidationError: { message: 'Unable to validate BOID' } };
        }
      }),
      catchError((error) => {
        return of({ boidValidationError: { message: 'Error validating BOID' } });
      })
    );
  };

  boId = new FormControl('', [], [this.boidAvailabilityValidator]);

  constructor(
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private superAdminService: SuperAdminService,
    private fb: FormBuilder,
    private http: HttpClient,
    private httpService: HttpService
  ) {
    this.route.params.subscribe((params) => {
      // this.loadData(params['id'], params['uid']);
      this.userId = params['uid'];
      this.pId = params['id'];

      this.actTab = params['tab'] || 'basic';
    });
  }

  async ngOnInit() {
    try {
      this.dataItem = await this.superAdminService.getPrdSignup(this.pId, this.userId);
      console.log(this.dataItem);
      this.signupActionTimeline();
      await this.getCheckListData();
    } catch (error) {
      console.log(error);
    }
    this.cdRef.detectChanges();
  }
  async getCheckListData() {
    try {
      let data = await this.superAdminService.getCompletionDetails(this.dataItem.id);
      console.log(data);
      this.investerCodeSubmitted = data.investorCode ? true : false;
      this.cdRef.detectChanges();
      this.bindPrdCheckList(data);
      this.boId.setValue(data.boId);
    } catch (error) {
      console.log(error);
    }
  }
  sectionToggle(section: string) {
    this.toggleStatus[section] = !this.toggleStatus[section];
  }
  activeTab(tab: string) {
    this.actTab = tab;
  }
  downloadAttachment(attachment: any) {
    // this.utilService.downloadAttachment(attachment);
  }
  async signupActionTimeline() {
    try {
      this.signUpActionInProgress = true;
      this.signUpActionList = await this.superAdminService.signUpactionTimeline(this.dataItem.id);

      this.signUpActionInProgress = false;
      this.cdRef.detectChanges();
    } catch (e) {
      this.signUpActionInProgress = false;
    }
    console.log(this.signUpActionList);
    this.cdRef.detectChanges();
  }

  bindPrdCheckList(data?) {
    this.confirmSignupFG = this.fb.group({
      // productSignupId: [(data && data.productSignupId) || this.dataItem.id, [GlobalValidators.required]],
      informationChecked: [(data && data.informationChecked) || false, [GlobalValidators.required]],
      documentsChecked: [(data && data.documentsChecked) || false, [GlobalValidators.required]],
      investorCode: [(data && data.investorCode) || ''],
      // boId: [(data && data.boId) || this.dataItem?.values?.boId || '', [], [this.boidAvailabilityValidator]],
    });
  }

  // Helper method to get BOID validation error message
  getBoidValidationError(): string {
    const boIdControl = this.confirmSignupFG.get('boId');
    if (boIdControl && boIdControl.errors) {
      if (boIdControl.errors['boidNotExists']) {
        return boIdControl.errors['boidNotExists'].message;
      }
      if (boIdControl.errors['boidValidationError']) {
        return boIdControl.errors['boidValidationError'].message;
      }
    }
    return '';
  }

  // Helper method to check if BOID is being validated
  isBoidValidating(): boolean {
    const boIdControl = this.confirmSignupFG.get('boId');
    return boIdControl ? boIdControl.pending : false;
  }

  async confirmSignup(usform: NgForm) {
    console.log(usform);
    if (usform.invalid) {
      return;
    }
    try {
      await this.superAdminService.confirmSignup(this.dataItem.id, usform.value);
      this.investerCodeSubmitted = true;
      this.cdRef.detectChanges();

      // window.location.reload();
    } catch (error) {}
    console.log(usform.value);
  }

  async downloadFileFromUrl(path = '/products/download-bo-setup-file') {
    try {
      if (!this.dataItem || !this.dataItem.id) {
        console.error('Signup ID not available');
        return;
      }

      const url = `${path}?signupId=${this.dataItem.id}`;
      const token = localStorage['atk'];
      const headers = new HttpHeaders().set('Authorization', token && 'Bearer ' + token).set('Content-Type', 'application/json');
      const formattedUrl = this.httpService.baseApiUrl + this.httpService.baseApiPath + url;

      const response: any = await this.http.get(formattedUrl, { headers }).toPromise();

      if (response && response.fileContent) {
        this.dataItem.productStatus = 'Approval Pending';
        console.log(this.dataItem);
        this.cdRef.detectChanges();
        // Convert base64 string to blob
        const byteCharacters = atob(response.fileContent);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray]);

        // Use fileName from response or fallback to default
        const fileName = `BO-Setup-File-${this.dataItem?.values?.nationalId || this.dataItem?.values.email}`;
        this.downloadFile(blob, fileName);
      } else {
        console.error('Invalid response format');
      }
    } catch (error) {
      console.log(error);
    }
  }

  downloadFile(blob: Blob, fileName: string): void {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), 1);
    this.cdRef.detectChanges();
  }
  async downloadSignature() {
    try {
      this.signatureInProgress = true;
      if (!this.dataItem || !this.dataItem.id) {
        console.error('Signup ID not available');
        this.signatureInProgress = false;
        this.cdRef.detectChanges();
        return;
      }

      const url = `/products/download-signature-file?signupId=${this.dataItem.id}`;
      const token = localStorage['atk'];
      const headers = new HttpHeaders().set('Authorization', token && 'Bearer ' + token).set('Content-Type', 'application/json');
      const formattedUrl = this.httpService.baseApiUrl + this.httpService.baseApiPath + url;

      const response: any = await this.http.get(formattedUrl, { headers }).toPromise();

      if (response && response.fileContent) {
        // Convert base64 string to blob
        const byteCharacters = atob(response.fileContent);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/zip' });

        // Use fileName from response or fallback to default
        let anupsSignatureCode = '03064400';
        // first 03 is CDBL module code, its fixed. 0 is separator, its fixed. 64400 is our DP ID, it is also fixed. rest is current date in numeric.
        const now = new Date();
        const currentDate = `${String(now.getDate()).padStart(2, '0')}${String(now.getMonth() + 1).padStart(2, '0')}${now.getFullYear()}`;
        const fileName = `${anupsSignatureCode}${currentDate}.zip`;
        this.downloadFile(blob, fileName);
      } else {
        console.error('Invalid response format');
      }

      this.signatureInProgress = false;
      this.cdRef.detectChanges();
    } catch (error) {
      console.error('Error downloading signature file:', error);
      this.signatureInProgress = false;
      this.cdRef.detectChanges();
    }
  }
  async approveSignup() {
    try {
      this.approvalInProgress = true;
      // await this.superAdminService.confirmSignup(this.dataItem.id, { ...this.confirmSignupFG.value, boId: this.boId.value });
      await this.superAdminService.approveSignup(this.dataItem.id, { boId: this.boId.value });
      this.approvalInProgress = false;
      this.dataItem.productStatus = 'Approved';
      this.successfullyApproved = true;
      setTimeout(() => {
        this.successfullyApproved = false;
      }, 3000);
      this.cdRef.detectChanges();
      // window.location.reload();
    } catch (error) {
      this.approvalInProgress = false;
      console.log(error);
    }
  }
  async downloadApplication() {
    try {
      this.downloadApplicationInProgress = true;
      this.downloadApplicationError = null;
      if (!this.dataItem || !this.dataItem.id) {
        this.downloadApplicationError = 'Signup ID not available';
        this.downloadApplicationInProgress = false;
        this.cdRef.detectChanges();
        return;
      }

      const url = `/products/download-report?signupId=${this.dataItem.id}&token=${localStorage['atk']}`;
      const token = localStorage['atk'];
      const headers = new HttpHeaders().set('Authorization', token && 'Bearer ' + token);
      const formattedUrl = this.httpService.baseApiUrl + this.httpService.baseApiPath + url;

      // Try to get response as blob first (most common for PDF downloads)
      try {
        const blob: Blob = await this.http.get(formattedUrl, { headers, responseType: 'blob' }).toPromise();

        // Check if the blob is actually an error response (JSON error wrapped in blob)
        if (blob.type === 'application/json' || blob.size < 100) {
          const text = await blob.text();
          try {
            const errorResponse = JSON.parse(text);
            this.downloadApplicationError = errorResponse.message || errorResponse.error || 'Failed to download application report';
          } catch (e) {
            this.downloadApplicationError = text || 'Failed to download application report';
          }
          this.downloadApplicationInProgress = false;
          this.cdRef.detectChanges();
          return;
        }

        // If it's a valid PDF blob, download it directly
        if (blob && (blob.type === 'application/pdf' || blob.type === '' || blob.size > 0)) {
          const fileName = `BO-Application-${this.dataItem.values?.nationalId || this.dataItem?.values.email}.pdf`;
          this.downloadFile(blob, fileName);
          this.downloadApplicationInProgress = false;
          this.cdRef.detectChanges();
          return;
        }
      } catch (blobError) {
        // If blob request fails, try as JSON/text (might be base64 encoded)
        console.log('Blob request failed, trying alternative format:', blobError);
      }

      // Fallback: Try to get response as JSON or text (for base64 encoded responses)
      let response: any;
      try {
        response = await this.http.get(formattedUrl, { headers }).toPromise();
      } catch (err) {
        response = await this.http.get(formattedUrl, { headers, responseType: 'text' }).toPromise();
      }

      // Check if response is a base64 string (either directly or in fileContent property)
      let base64String: string = '';

      if (typeof response === 'string') {
        // Try to parse as JSON first (might be JSON string)
        try {
          const parsed = JSON.parse(response);
          if (parsed && parsed.fileContent) {
            base64String = parsed.fileContent;
          } else {
            base64String = response;
          }
        } catch (e) {
          // Not JSON, use as base64 string directly
          base64String = response;
        }
      } else if (response && response.fileContent) {
        // Response is JSON object with fileContent property
        base64String = response.fileContent;
      } else {
        this.downloadApplicationError = 'Invalid response format';
        this.downloadApplicationInProgress = false;
        this.cdRef.detectChanges();
        return;
      }

      // Clean the base64 string: remove data URL prefix if present, and remove whitespace
      base64String = base64String.trim();

      // Try URL decoding in case the response is URL-encoded
      try {
        base64String = decodeURIComponent(base64String);
      } catch (e) {
        // Not URL-encoded, continue with original string
      }

      // Remove data URL prefix (e.g., "data:application/pdf;base64,")
      if (base64String.includes(',')) {
        base64String = base64String.split(',')[1];
      }
      // Remove all whitespace (spaces, newlines, tabs)
      base64String = base64String.replace(/\s/g, '');

      // Validate base64 string (should only contain base64 characters)
      const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
      if (!base64Regex.test(base64String)) {
        this.downloadApplicationError = 'Invalid base64 format in response';
        this.downloadApplicationInProgress = false;
        this.cdRef.detectChanges();
        console.error('Invalid base64 characters detected');
        console.error('Base64 string preview:', base64String.substring(0, 200));
        return;
      }

      // Convert base64 string to blob
      try {
        const binaryString = atob(base64String);
        const bytes = new Uint8Array(binaryString.length);
        for (let i = 0; i < binaryString.length; i++) {
          bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: 'application/pdf' });

        const fileName =
          typeof response === 'object' && response.fileName ? response.fileName : `Application-Report-${this.dataItem.id}.pdf`;
        this.downloadFile(blob, fileName);
      } catch (decodeError: any) {
        this.downloadApplicationError = `Failed to decode PDF file: ${decodeError?.message || 'Invalid base64 format'}`;
        this.downloadApplicationInProgress = false;
        this.cdRef.detectChanges();
        console.error('Base64 decode error:', decodeError);
        return;
      }

      this.downloadApplicationInProgress = false;
      this.cdRef.detectChanges();
    } catch (error: any) {
      this.downloadApplicationInProgress = false;
      this.downloadApplicationError =
        error?.error?.message || error?.message || 'An error occurred while downloading the application report';
      this.cdRef.detectChanges();
      console.log(error);
    }
  }
}
